import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';

import Select from 'react-select';
import moment from 'moment';
import Rating from "react-rating";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Pagination } from 'antd';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';

import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import { getCookie } from '../common_component/cookie.js';
import PageError from '../common_component/PageError.js';
import PageLoader from "../common_component/PageLoader.js";

function EcommerceProductReviewList(props) {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()
    const [ecommerceProductReviewListApiState, setEcommerceProductReviewListApiState] = useState(false)
    const [approveModalShow, setApproveModalShow] = useState(false);
    const [submitButtonState, setSubmitButtonState] = useState(false);

    const [flowModalShow, setFlowModalShow] = useState(false);
    const [flow_img, setflow_img] = useState("");
    const daterange_picker_ref = useRef();

    const [reviews, setReviews] = useState([]);
    const [averageRating, setAverageRating] = useState(0);
    const [starCount, setStarCount] = useState([]);
    const [ratingType, setRatingType] = useState("All");
    const [statusType, setStatusType] = useState("All");
    const [productName, setProductName] = useState("");
    const statusTypeArray = ["Pending", "Approved"];
    const ratingTypeArray = [1, 2, 3, 4, 5];
    const [unique_id, setunique_id] = useState("")

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(30, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const apiController = useRef(new AbortController())

    var page_name = "ecommerce-product-review-list";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const approveReview = () => {
        var object = {};
        object.unique_id = unique_id
        object.user_email = user.email

        object.organization_id = organization_id
        object.page_name = page_name;

        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-ecommerce-product-review`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Review Approved successfully!`, "success").then(() => {
                    setApproveModalShow(false);
                    getEcommerceProductReviewList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType, ratingType);
                })
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    async function getEcommerceProductReviewList(cp, rpp, search_v, sd, ed, rt) {
        try {
            if (ecommerceProductReviewListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setEcommerceProductReviewListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-product-review`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "status_type": statusType, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "rating_type": ratingType, "props_value": props.match.params.id !== undefined ? props.match.params.id : "", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce order list api error"

            const rating_distribution_data = body.data.rating_distribution_data;
            if (props.match.params.id !== undefined) {
                setProductName(body.data.product_name);
            }
            setAverageRating(body.data.total_rating / body.data.count);
            const starDistribution = [5, 4, 3, 2, 1].map((stars) => ({
                stars,
                percentage: rating_distribution_data.find((data) => data.rate === stars) !== undefined ?
                    rating_distribution_data.find((data) => data.rate === stars).percentage : 0
            }));
            setReviews(body.data.list);
            setStarCount(starDistribution);
            setListCount(body.data.count);
            setEcommerceProductReviewListApiState(false);
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getEcommerceProductReviewList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType, ratingType);
            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)

                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getEcommerceProductReviewList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType, ratingType)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate, statusType, ratingType])


    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Product Review List</h1>
                    {(state === 1 && props.match.params.id !== undefined) && <span><span className="fw-bold">Item:- </span><span className='text-info'>{productName}</span></span>}
                </div>
                <div>
                    {state === 1 ?
                        <>
                            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                                {reviews.length > 0 &&
                                    <div className="card card-flush p-4">
                                        <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
                                            <h4 className="mb-0">Overall Average Rating</h4>
                                            <h1 className="m-0">{averageRating.toFixed(1)}</h1>
                                            <span className="text-warning ml-2">{Array.from({ length: 5 }, (_, i) => (<i key={i} className={`fas fa-star ${i < Math.round(averageRating) ? 'text-warning' : 'text-muted'}`}></i>))}</span>
                                            <span className="text-muted">{listCount} reviews</span>
                                        </div>

                                        {/* Rating Distribution */}
                                        <div>
                                            {starCount.map((rating) => (
                                                <div key={rating.stars} className="mb-3">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            {rating.stars} Stars
                                                        </div>
                                                        <div>{rating.percentage.toFixed(1)}%</div>
                                                    </div>
                                                    <div className="progress" style={{ height: '10px' }}>
                                                        <div
                                                            className={`progress-bar bg-${rating.stars >= 4
                                                                ? 'success'
                                                                : rating.stars === 3
                                                                    ? 'warning'
                                                                    : 'danger'
                                                                }`}
                                                            role="progressbar"
                                                            style={{ width: `${rating.percentage}%` }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>}

                                <div className="card card-flush py-4">
                                    <div className="card-header">
                                        <div className="row flex-grow-1 align-items-center">
                                            {/* React-Select Dropdown */}
                                            <div className="col-12 col-sm-6 col-lg-4 mb-2 mb-sm-0">
                                                <Select
                                                    options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x, value: x } })]}
                                                    onChange={(event) => { setStatusType(event.value); }}
                                                    value={statusType !== "All" ? statusTypeArray.find(elem => elem.value == statusType) : { label: "All", value: "All" }}
                                                    placeholder="Select..."
                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-4">
                                                <DateRangePickerComponent
                                                    ref={daterange_picker_ref}
                                                    allowEdit={false}
                                                    showClearButton={false}
                                                    focus={() => { daterange_picker_ref.current.show() }}
                                                    delayUpdate={true}
                                                    presets={[
                                                        { label: 'Today', start: new Date(), end: new Date() },
                                                        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                                    ]}
                                                    change={(e) => {
                                                        setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                        setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                    }}
                                                    startDate={new Date(startDate)}
                                                    endDate={new Date(endDate)}
                                                    max={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-4 mb-2 mb-sm-0">
                                                <Select
                                                    options={[{ label: "All", value: "All" }, ...ratingTypeArray.map(x => { return { label: `${x} Star`, value: x } })]}
                                                    onChange={(event) => { setRatingType(event.value); }}
                                                    value={ratingType !== "All" ? { label: `${ratingType} Star`, value: ratingType } : { label: "All", value: "All" }}
                                                    placeholder="Select..."
                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>
                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                ecommerceProductReviewListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    reviews.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                            <div className="row align-self-stretch">
                                                                {reviews.map((review, index) => (
                                                                    <div key={index} className="col-md-6 p-3">
                                                                        <div className="d-flex flex-column" style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", minHeight: "200px" }}>
                                                                            <div className="d-flex justify-content-between">
                                                                                <span><span className='fw-bold me-2'>{review.account_name}</span><span className={`badge ${review.add_status == "Pending" ? "badge-warning" : "badge-success"}`}>{review.add_status}</span></span>
                                                                                <Rating
                                                                                    initialRating={review.rating}
                                                                                    readonly
                                                                                    emptySymbol="far fa-star"
                                                                                    fullSymbol="fas fa-star"
                                                                                    style={{ color: "#fdbc0a" }}
                                                                                />
                                                                            </div>
                                                                            <span className="text-primary">Reviewed on {moment(review.add_date_time).format("ll")}</span>
                                                                            {props.match.params.id === undefined &&
                                                                                <span><span class="fw-bold">Item:- </span><span class="text-info">{review.product_name}</span></span>}
                                                                            <div className="text-gray-600 fw-bold flex-grow-1 my-2">{review.review}</div>
                                                                            <div class="d-flex align-items-center">
                                                                                {review.document_array !== undefined && review.document_array.map((image, index1) => (
                                                                                    <div class="symbol symbol-50px me-3 cursor-pointer" onClick={(e) => { setflow_img(image.filename); setFlowModalShow(true); }}>
                                                                                        <img src={`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/ecom_review_docs/${organization_id}/${image.filename}`} className="" alt="" />
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            {review.add_status == "Pending" &&
                                                                                <div className='text-end'><button onClick={(e) => { setunique_id(review.unique_id); setApproveModalShow(true); }} className="btn btn-primary">Approve</button></div>}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No reviews are available </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        state === 2 ?
                            <PageLoader />
                            :
                            <PageError />
                    }
                </div>
            </div>

            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-45">
                <Modal.Header>
                    <Modal.Title>
                        <span>Review Image</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <img src={`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/ecom_review_docs/${organization_id}/${flow_img}`} style={{ height: "300px", padding: '25px', marginTop: '0' }} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { setFlowModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal >

            <Modal show={approveModalShow} onHide={() => { setApproveModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Approve Review</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                <h3 className="mt-3">Are you sure about Approve Review?</h3>
                            </div>
                        </div>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setApproveModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => {
                            approveReview();
                        }} className="btn btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}><span className="indicator-label">Approve </span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default EcommerceProductReviewList;